import {prop} from "../../decorators/property";

export class AdvancedSearchFieldSelectorModel extends Backbone.Model {

    @prop() public FilterText = "";

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/advanced-search-field-selector.ts